import loadable from '@loadable/component';
import React from 'react';
import PropTypes from 'prop-types';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "product" */ './product-properties')
);

const ProductPropertiesLoader = props => {
  if (!props.properties || !props.properties.nodes) {
    return null;
  }

  return <LoadableComponent {...props} />;
};

ProductPropertiesLoader.propTypes = {
  properties: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

ProductPropertiesLoader.defaultProps = {
  properties: undefined,
};

export default ProductPropertiesLoader;
